import { createConsumer } from "@rails/actioncable";

var consumer = createConsumer();

console.log('TestChannel initialized');

consumer.subscriptions.create(
  { channel: "TestChannel" },
  {
    received(data) {
      console.log(data);
    },
  },
);
